module.exports = __webpack_public_path__ + "media/recupel1.7ce56858.mp4";